import React, { useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const WELCOME_VIDEO_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_command-center-488/artifacts/b1a83742eaf53ce1_Welcome%20to%20Mission%20Control.mp4";

export function WelcomeVideoPlayer({ className = "", autoPlay = false }) {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    if (!autoPlay || !v) return;
    v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
  }, [autoPlay]);
  return (
    <video ref={ref} data-testid="welcome-video" src={WELCOME_VIDEO_URL} controls playsInline preload="auto"
      className={`w-full aspect-video rounded-2xl bg-black shadow-[0_20px_60px_rgba(0,0,0,0.45)] ${className}`} />
  );
}

export function WelcomeVideoDialog({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white border-[#EEEFEF] max-w-3xl" data-testid="welcome-video-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Welcome to Mission Control</DialogTitle>
          <DialogDescription className="text-[#9FA1A4]">A one-minute tour of your workspace.</DialogDescription>
        </DialogHeader>
        <WelcomeVideoPlayer />
      </DialogContent>
    </Dialog>
  );
}
